import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'react-phone-number-input/style.css';
import { BrowserRouter } from 'react-router-dom';
import './App.scss';
import { NotificationContextProvider } from './contexts/NotificationContext';
import { IsOnlineContextProvider } from './contexts/IsOnlineContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import MainRoutes from './routes/mainRoutes';
import { UserContextProvider } from './contexts/UserContext';
import Preloader from './components/preLoader/PreLoader';
import { Suspense } from 'react';
import { localDataService } from './services/localDataService';
import { useEffect } from 'react';
import dayjs from 'dayjs';
import i18n from './locale/i18n';
import 'dayjs/locale/es'; // Spanish
import 'dayjs/locale/en';
import ApexCharts from "apexcharts";

const queryClient = new QueryClient();

if (typeof window !== "undefined") {
  (window as any).ApexCharts = ApexCharts;
}

function App() {
  useEffect(() => {
    const initializeLocalData = async () => {
      try {
        await localDataService.init();
      } catch (error) {
        console.error('Failed to initialize local-first architecture:', error);
      }
    };

    initializeLocalData();
  }, []);

  useEffect(() => {
    const handleLanguageChange = (lng: string) => {
      dayjs.locale(lng === 'es' ? 'es' : 'en');
    };

    i18n.on('languageChanged', handleLanguageChange);

    // set initial locale
    handleLanguageChange(i18n.language);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n.language]);

  useEffect(() => {
    const loader = document.getElementById('initialLoading');
    if (loader) {
      loader.remove();
    }
  }, [])

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <UserContextProvider>
          <ThemeContextProvider>
            <NotificationContextProvider>
              <IsOnlineContextProvider>
                <Suspense fallback={<Preloader />}>
                  <MainRoutes />
                </Suspense>
              </IsOnlineContextProvider>
            </NotificationContextProvider>
          </ThemeContextProvider>
        </UserContextProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
